import loadable from "@loadable/component";
import {
  getKey,
  setKey,
  setKey as setLocalKey,
} from "../../helpers/sessionKey";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import Spinner from "../../components/Reusable/Spinner";

const LoginFormComponent = loadable(
  () => import("../../components/Auth/LoginForm")
);

const LoginPage = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [""],
  });

  let shouldShowWelcome = window.localStorage.getItem("shouldShowWelcome");

  const { data: checkUser, isLoading } = useGetHook({
    queryKey: [`first-user`],
    url: `${APIS.CHECK_USER}`,
    params: {},
  });
  const handleLogin = async (values: any, setError: any) => {
    const url = `${APIS.TOKEN}`;
    let formData = {
      ...values,
    };

    try {
      const res = await mutateAsync({ url, formData, setError });
      console.log(res.data, "login res");
      // return;
      if (res.status === 200) {
        setLocalKey("token", res.data?.access);
        setLocalKey("schema_name", res.data?.default_schema);
        setLocalKey("refresh-token", res?.data?.refresh);
        if (shouldShowWelcome === null) {
          setKey("shouldShowWelcome", "true");
        }
        window.location.replace("/");
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <LoginFormComponent
          handleLogin={handleLogin}
          isLoading={isPostLoading}
          checkUser={checkUser}
        />
      )}
    </>
  );
};

export default LoginPage;
